// biome-ignore lint/suspicious/noExplicitAny: It's ok
type Fn = (arg: any) => any;

export const compose =
  (...functions: Fn[]) =>
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint -- Ok
  <Data>(data: Data) =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- It's ok
    functions.reduceRight((acc, fn) => fn(acc), data);
